export default __webpack_public_path__ + "static/media/GlobeIcon.0ecf35de.svg";